export { FastshiftTableWrapper } from './fastshift-table-wrapper';
